import RsrcBlueprints from "./RsrcBlueprints.js";
import RsrcBlueprint from "./RsrcBlueprint.js";
export default class RsrcBlueprintAnalyzer {
  constructor(options) {
    const {
      blueprints,
      molten
    } = options;
    this.options = options;
    this.molten = molten;
    this.lookup = new Map();
    this.blueprints = blueprints.reduce((prev, b) => {
      const bp = new RsrcBlueprint(b, {
        ...options,
        blueprints: this.lookup
      });
      if (!bp.hasTag('is:hidden')) {
        this.lookup.set(bp.id, bp); // look up by id
        this.lookup.set(bp.type, bp); // look up by alias if available
        prev.push(bp);
      }
      return prev;
    }, []);
    this.blueprints.forEach(bp => {
      RsrcBlueprints.add(bp);
    });
  }
  async install() {
    this.installDataSources();
  }
  installDataSources() {
    this.blueprints.forEach(b => {
      this.molten.addPlugin('DataSource', {
        type: b.type,
        dataSource: b.getDataSource()
      });
    });
  }
}